import type { Goal, Profile, Sex } from "@bioflow/contracts";

/** Подписи целей — дословно с экрана 5 ТЗ. */
export const GOAL_LABELS: Record<Goal, string> = {
  lose_weight: "Снизить вес",
  control_appetite: "Контролировать аппетит",
  reduce_cravings: "Уменьшить тягу к еде",
  maintain_weight: "Удерживать достигнутый вес",
  explore: "Хочу разобраться, подходит ли мне тирзепатид",
};

export const GOALS = Object.keys(GOAL_LABELS) as Goal[];

export const SEX_LABELS: Record<Sex, string> = {
  male: "Мужской",
  female: "Женский",
};

/** BMI с запятой, как в ТЗ («28,4»). */
export const formatBmi = (bmi: number) => bmi.toFixed(1).replace(".", ",");

/** Тот же расчёт, что на сервере — для превью на экране ввода до сохранения. */
export function calculateBmi(heightCm: number, weightKg: number): number {
  const meters = heightCm / 100;
  return Math.round((weightKg / (meters * meters)) * 10) / 10;
}

/** Заполнены ли данные для персонального блока на главной. */
export const hasBodyData = (profile: Profile | undefined) =>
  Boolean(profile && profile.heightCm !== null && profile.weightKg !== null);

/** Пределы полей — те же, что в схеме API, чтобы форма не пропускала лишнего. */
export const HEIGHT_RANGE = { min: 100, max: 250 } as const;
export const WEIGHT_RANGE = { min: 30, max: 400 } as const;
